import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FormFilter from './form';

const FilterAmount = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <div className="pmi-my-3">
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-amount-auth-content"
          id="panel-amount-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

FilterAmount.displayName = 'Filter Amount';

export default FilterAmount;
